var map = {
	"./404.md": 493,
	"./_template.jsx": 375,
	"./articles/2015-05-01-hello-world/index.md": 494,
	"./articles/2015-05-06-my-second-post/index.md": 495,
	"./articles/2015-05-28-hi-folks/index.md": 496,
	"./articles/2016-05-29-the-humble-floppy-disk/index.md": 497,
	"./index.jsx": 498,
	"./pages/about/index.md": 499,
	"./pages/contact/index.md": 500
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 492;



/*****************
 ** WEBPACK FOOTER
 ** . (coffee|cjsx|jsx|js|markdown|md|ipynb|html|json|yaml|toml)$
 ** module id = 492
 ** module chunks = 0
 **/